import {
  ApplePay,
  GooglePay,
  Mastercard,
  Visa,
} from '@time-line/components/icons';
import type { NavGroup } from '@time-line/components/types';
import {
  FOOTER_ABOUT_NAV,
  LEGAL_NAV,
  SKINCARE_EXPLORE_NAV,
  SKINCARE_LEGAL_NAV,
  SUPPORT_NAV,
} from 'lib/constants/navigation';

export const PAYMENT_PROVIDERS = [
  { icon: <GooglePay width="40px" height="16px" /> },
  { icon: <ApplePay width="38px" height="16px" /> },
  { icon: <Mastercard width="24px" height="16px" /> },
  { icon: <Visa width="36px" height="16px" /> },
];

export const FOOTER_CONTENT: {
  legal: NavGroup;
  nav: NavGroup[];
  skincareNav: NavGroup[];
  skincareLegal: NavGroup;
} = {
  legal: LEGAL_NAV,
  nav: [FOOTER_ABOUT_NAV, SUPPORT_NAV],
  skincareNav: [SKINCARE_EXPLORE_NAV, SUPPORT_NAV],
  skincareLegal: SKINCARE_LEGAL_NAV,
};

export const FOOTER_FDA_DISCLAIMER =
  '† These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.';

export const FOOTER_REFERENCES =
  'References: *Nutrition studies: 500mg Mitopure® have been shown to (1) induce gene expression related to mitochondria function and metabolism and (2) increase the strength of the hamstring leg muscle in measures of knee extension and flexion in overweight 40-65 year olds. Data from two randomized double-blind placebo-controlled human clinical trials. **Nutrition NOURISH Study: 500mg Mitopure® have been shown to deliver at least 6 times higher Urolithin A plasma levels over 24 hours (area under the curve) than 8 ounces (240ml) of pomegranate juice in a randomized human clinical trial.';
